import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, switchMap, filter, take } from 'rxjs/operators';
import { ToastController } from '@ionic/angular';
import { TokenService } from '../services/token.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    isRefreshingToken = false;

    constructor(private tokenService: TokenService, private toastCtrl: ToastController) {
        this.tokenService.loadToken()
    }

    // Intercept every HTTP call
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this.tokenService.loadToken()

        // console.log(request.url)
        // console.log(1234)

        if (this.isInBlockedList(request.url)) {
            // console.log(request.url + '/nono')
            return next.handle(request);
        } else {
            // console.log(request.url + '/yesyes')
            return next.handle(this.addToken(request)).pipe(
                catchError(err => {
                    if (err instanceof HttpErrorResponse) {
                        switch (err.status) {
                            case 400:
                                return this.handle400Error(err);
                            case 401:
                                return this.handle401Error(request, next);
                            default:
                                return throwError(err);
                        }
                    } else {
                        return throwError(err);
                    }
                })
            );
        }
    }
    // updateMultiModeUids

    // Filter out URLs where you don't want to add the token!
    private isInBlockedList(url: string): Boolean {
        // Example: Filter out our login and logout API call
        // console.log(url)
        let apiArr = [
            'getOutstandingTask',
            'getBankSummary',
            'getInvoiceDetails',
            'getAccounts',
            'getItems',
            'getContacts',
            'getPayments',
            'getOutstandingTask',
            'getInvoices',
            'filterXeroInvoice',
            'deleteAccount',
            'fileUploads',
            'attachFiles',
            'getAttachements',
            'getFileContent',
            'getNotes',
            'getCurrency',
            'addNotes',
            'createInvoice',
            'getFileContent',
            'connectedOrganisation'
        ]

        let endPoint = url.split('/').pop()

        if (!apiArr.find(b => b.includes(endPoint))) {
            return true;
        } else {
            console.log(endPoint)
            // console.log(23)
            return false;
        }
    }

    // Add our current access token from the service if present
    private addToken(req: HttpRequest<any>) {
        if (localStorage.getItem('XERO_ACCESS_TOKEN_KEY')) {
            return req.clone({
                headers: new HttpHeaders({
                    Authorization: `Bearer ${localStorage.getItem('XERO_ACCESS_TOKEN_KEY')}`
                })
            });
        } else {
            return req;
        }
    }

    // We are not just authorized, we couldn't refresh token
    // or something else along the caching went wrong!
    private async handle400Error(err) {
        // Potentially check the exact error reason for the 400
        // then log out the user automatically
        console.log(err)
        const toast = await this.toastCtrl.create({
            message: 'Your xero session is expired, Please re-login to xero!',
            duration: 2000
        });

        toast.present();
        this.tokenService.logout();
        return of(null);
    }

    // Indicates our access token is invalid, try to load a new one
    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        // Check if another call is already using the refresh logic
        if (!this.isRefreshingToken) {

            this.tokenSubject.next(null);
            this.isRefreshingToken = true;
            this.tokenService.currentAccessToken = null;

            // First, get a new access token
            return this.tokenService.refreshToken().pipe(
                switchMap((token: any) => {
                    console.log(token)
                    if (token.accessToken && token.refreshToken && token.success == true) {
                        // Store the new token
                        const accessToken = token.accessToken;

                        const refreshToken = token.refreshToken
                        localStorage.setItem('XERO_REFRESH_TOKEN_KEY', refreshToken)

                        return this.tokenService.storeAccessToken(accessToken).pipe(
                            switchMap(_ => {
                                // Use the subject so other calls can continue with the new token
                                this.tokenSubject.next(accessToken);
                                // Perform the initial request again with the new token
                                return next.handle(this.addToken(request));

                            })
                        );
                    } else {
                        // No new token or other problem occurred
                        this.tokenService.logout()
                        return of(null);
                    }
                }),
                finalize(() => {
                    // Unblock the token reload logic when everything is done
                    this.isRefreshingToken = false;
                })
            );
        } else {
            // "Queue" other calls while we load a new token
            return this.tokenSubject.pipe(
                filter(token => token !== null),
                take(1),
                switchMap(token => {
                    // Perform the request again now that we got a new token!
                    return next.handle(this.addToken(request));
                })
            );
        }
    }

}